import { FC } from "react";
import { FlatList, Text, TouchableOpacity } from "react-native";
import { useAppDispatch } from "src/redux";
import { saveRecentSearch } from "src/util/search";

type tRecentSearchesProps = {
  myRecentSearches: Array<string> | undefined;
  myRenderSearches?: boolean;
};

const RecentSearches: FC<tRecentSearchesProps> = ({ myRecentSearches, myRenderSearches = true }) => {
  const dispatch = useAppDispatch();
  // const rSearchData = useSelector(({ SearchReducer }) => SearchReducer.rSearchData);
  if (!myRenderSearches) {
    return null;
  }

  const dispatchCurrentSearch = (myItem: string) => {
    dispatch({
      type: "UPDATE_SEARCH",
      rSearchData: {
        commissionData: {
          currentSearch: myItem,
          recentSearches: saveRecentSearch(myItem, myRecentSearches),
        },
      },
    });
  };

  const renderRecentSearches = ({ item }: { item: string }) => {
    return (
      <TouchableOpacity onPress={() => dispatchCurrentSearch(item)}>
        <Text>{item}</Text>
      </TouchableOpacity>
    );
  };

  return <FlatList renderItem={renderRecentSearches} data={myRecentSearches ?? ["No Recent Searches"]} />;
};

export default RecentSearches;
